<p-toast></p-toast>
<div class="login-page">
  <div class="login-bg-img">
    <img src="./assets/images/login-bg-img.webp" alt="">
  </div>
  <div class="container">
    <div class="login-container">
      <div class="welcome" *ngIf="!linkUsed">
        <h2>Welcome <ng-container *ngIf="userData">{{ (userData?.first_name ?? '') }} {{ (userData?.last_name ?? '') }}</ng-container> to {{ tourData?.property_id?.name ?? 'Petrie' }}</h2>
      </div>

      <!-- Show message if link already used -->
      <div *ngIf="linkUsed" class="alert alert-info">
        <h3 [innerHTML]="message"></h3>
      </div>

      <!-- Show form only if link is not used -->
      <form *ngIf="!linkUsed" [formGroup]="tourAcceptForm" (ngSubmit)="onSubmit()">
        <h4>
          <strong>Are you sure you want to accept this tour<ng-container *ngIf="tourData"> for {{ tourData?.plan_name }}</ng-container>?</strong>
          <ng-container *ngIf="tourData">
            <br/><br/>
            <strong>Schedule Date: </strong> {{ tourData.date+' '+tourData.time | timezoneDate:tourData?.property_id?.timezone:'date' }}
            <br/>
            <strong>Schedule Time: </strong> {{ tourData.date+' '+tourData.time | timezoneDate:tourData?.property_id?.timezone:'time' }}
          </ng-container>
        </h4>

        <!-- Confirm button -->
        <p-button type="submit" styleClass="w-100 mt-2" label="Yes, Confirm" severity="success">
        </p-button>

        <!-- Cancel button -->
        <p-button type="button" styleClass="w-100 mt-2" label="Cancel" severity="secondary" (click)="onCancel()">
        </p-button>
      </form>
    </div>
  </div>
</div>